import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import MatrixInput from './MatrixInput';
import * as Matrix from '../matrix/Matrix';
import range from 'lodash/range';

const MatrixOpenQuestion = props => {
  const {
    field_type,
    id,
    inputNamer = defaultInputNamer,
    isDisabled,
    name,
    number_of_fields,
    required,
    rows,
    _type,
    pre_text,
    post_text,
  } = props;
  return (
    <QuestionWrapper {...props}>
      <Matrix.Table>
        <Matrix.Head>
          {number_of_fields > 1 &&
            range(number_of_fields).map(n => (
              <th className="fs-12 ta-c fw-n p2" key={n}>
                {n + 1}
              </th>
            ))}
        </Matrix.Head>
        <Matrix.Body>
          {rows.map((row, rowIndex) => (
            <Matrix.Row
              id={row.id}
              key={rowIndex}
              questionId={id}
              text={row.text}
            >
              {range(number_of_fields).map(fieldIndex => (
                <React.Fragment key={fieldIndex}>
                  <td style={{width: "1em"}}>{pre_text}</td>
                  <td key={fieldIndex} className="p2">
                    <MatrixInput
                      className="mb0"
                      disabled={isDisabled}
                      fieldIndex={fieldIndex}
                      field_type={field_type}
                      name={inputNamer(_type, name, row.name)}
                      globalIndex={rowIndex * number_of_fields + fieldIndex}
                      questionId={id}
                      required={required}
                      rowIndex={rowIndex}
                      rowName={row.name}
                      />
                  </td>
                  <td style={{width: "4em"}}>{post_text}</td>
                </React.Fragment>
              ))}
            </Matrix.Row>
          ))}
        </Matrix.Body>
      </Matrix.Table>
    </QuestionWrapper>
  );
};

function defaultInputNamer(_type, questionName, rowName) {
  return `questions[${questionName}-${rowName}]`;
}

MatrixOpenQuestion.propTypes = {
  field_type: PropTypes.string,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  number_of_fields: PropTypes.number,
  required: PropTypes.bool,
  rows: PropTypes.array,
  text: PropTypes.string,
};

MatrixOpenQuestion.defaultProps = {
  number_of_fields: 1,
  rows: [],
};

export default MatrixOpenQuestion;
